<template>
  <div class="data-item">
    <div class="data-item_title">观看数据</div>

    <div class="data-item_content" ref="chartRef"></div>

    <div class="data-item_empty" v-if="emptyFlag">暂无数据</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chart: null,
      emptyFlag: true,
    };
  },

  props: ["liveData"],

  mounted() {
    window.addEventListener("resize", this.resizeChart);
  },
  methods: {
    setChartOption() {
      if (!this.$refs.chartRef) return;

      this.chart = this.$echarts.init(this.$refs.chartRef);
      const category = this.liveData.watch_data.time;
      const viewValue = this.liveData.watch_data.num.map((item) => Number(item));

      const options = {
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0%",
          top: "10%",
          containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "transparent",
          borderWidth: 0,
          borderColor: "transparent",
          formatter: function (params) {
            return `
              <div class="tooltip-box">${params[0].value}人</div>
            `;
          },
        },
        xAxis: {
          type: "category",
          data: category,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: function (params) {
              return `${params}分钟内`;
            },
          },
        },
        yAxis: {
          name: "单位: 人",
          nameTextStyle: {
            align: "right",
          },
          type: "value",
          splitLine: {
            lineStyle: {
              color: "rgba(238,238,238,0.1)",
            },
          },
        },
        series: [
          {
            type: "bar",
            data: viewValue,
            barWidth: 12,
            itemStyle: {
              color: "#00BAFF",
              borderRadius: 6,
            },
          },
        ],
      };

      this.emptyFlag = false;
      this.chart.setOption(options);
    },

    resizeChart() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .tooltip-box {
  min-width: 88px;
  height: 46px;
  background: rgba(24, 32, 55, 0.8);
  box-shadow: inset 0px 0px 95px 2px rgba(16, 108, 222, 0.25), inset 0px 0px 10px 2px rgba(0, 114, 255, 0.8);
  border-radius: 4px 4px 4px 4px;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  line-height: 46px;
  text-align: center;
  box-sizing: border-box;
  padding-inline: 20px;
}

.data-item {
  aspect-ratio: 509 / 352;
  position: relative;

  &_content {
    margin-top: 20px;
    height: calc(100% - 36px);
  }

  &_empty {
    height: calc(100% - 56px);
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: #ffffff7e;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
